import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { type JournalParams } from '../journal';
import ContactModel from 'donor-elf-web/models/contact';
import { AddContactItem } from 'donor-elf-web/controllers/funds/fund/journals/journal/add-contacts';

export default class JournalsIndexRoute extends Route {
  @service declare contactsCache: any;
  @service declare journalService: any;
  @service declare navbarSettings: any;

  async model() {
    // somewhere we are forgetting to remove deleted contact ids, so let's refresh everything
    await this.contactsCache.loadContacts({ forceLoad: true });
    await this.journalService.load();
    let journalId = (
      this.paramsFor('funds.fund.journals.journal') as JournalParams
    ).journalId;
    let journalInfo = this.journalService.journalInfoById(journalId);
    this.navbarSettings.title = `Add Contacts to ${journalInfo.journal.label} Journal`;
    return {
      journalInfo,
      contactItems: this.generateContactItems(journalInfo),
    };
  }

  generateContactItems(journalInfo: any) {
    return this.contactsCache.sortedContacts
      .filter((contact: ContactModel) => {
        return journalInfo.journal.contactIdsKeys[contact.id] !== true;
      })
      .map((contact: ContactModel) => {
        return new AddContactItem(contact);
      });
  }
}
